<template>
  <div>
    <div v-if="propPriceHide && propPrice" class="main-basic-info-price" :class="{'smaller-price':car.withoutVat,'discount':hasDiscount}">
      <div v-if="propStatus == 'standart' && !hasDiscount" class="main-basic-info-price__item">
        <span>{{ propOldCar ? 'Verð' : 'Verð frá' }}</span> <b>{{ price }}</b>
        <span style="margin-left: 5px;" v-if="car.withoutVat">án vsk.</span>
      </div>

      <div v-else-if="propStatus == 'in way'" class="main-basic-info-price__item">
        Verð með aukabúnaði <b>{{ price }}</b>
      </div>

      <!-- propStatus == 'discount' &&  -->
      <div v-else-if="hasDiscount" class="main-basic-info-price__item-discount">
        <div class="primary-block">
          <span class="label">{{ car.is_special_price ? 'Tilboðsverð' : 'Lækkað verð' }} </span>
          <span class="current-value">{{ priceDifference }}</span>
        </div>
        <div v-if="showOldPrice" class="secondary-block">
          <span class="start-value">{{ price }}</span>
          <span class="discount-value"><IconPriceDown/> {{ priceDiscount }}</span>
        </div>
      </div>
      <div class="main-basic-info-price__item loan-block" v-if="bankPrice !== null">
        <div>{{bankPrice | monthlyPayment}} / mán</div>
        <a :href="bankLink" target="_blank" class="bank-link">
          Reikna bílalán
        </a>
      </div>
    </div>
    <div v-else-if="propCheckPricee && propPrice" class="main-basic-info-price" :class="{ 'b-empty shine-short': !propLoaded }">
      <span style="font-weight: bold">Leitið til sölumanna</span>
    </div>
    <div v-else-if="propPrice" class="main-basic-info-price" :class="{ 'b-empty shine-short': !propLoaded }">
      <span style="font-weight: bold">Sérpöntun</span>
    </div>

    <div class="main-basic-info-price" v-if="false">
      <div class="main-basic-info-price__price-accessories">
        <span>Verð með aukabúnaði, </span> <span>Væntanlegur 20.10.20</span>
      </div>
    </div>
  </div>
</template>

<script>
import IconPriceDown from "@/components/svg/priceArrowDown"
import numeral from "numeral";

export default {
  components: {
    IconPriceDown
  },
  filters: {
    monthlyPayment: (value) => {
      const num = numeral(value)
      return !isNaN(value)
              ? `${num.format('0,0[.]00').replace(/,/g, '.')} kr.`
              : '-'
    },
  },
  props: {
    propPriceHide: {
      type: Boolean,
      default: true
    },
    propCheckPricee: {
      type: Boolean,
      default: true
    },
    propPrice: {
      type: Number,
      default: null
    },
    propDiscountPrice: {
      type: Number,
      default: null
    },
    propCurrency: {
      type: String,
      default: 'kr.'
    },

    // status - standart, in way, discount
    propStatus: {
      type: String,
      default: 'standart'
    },
    propLoaded: {
      type: Boolean,
      default: false
    },
    propOldCar: {
      type: Boolean,
      default: false
    },
    car: {
      type: [Object, Array]
    },
    isSpecialOffer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bankPrice: null
    }
  },
  created() {
    this.$root.$on('calc-price', price => {
      this.bankPrice = price
    })
  },
  computed: {
    bankLink() {
      let price
      if (this.propStatus == 'in way' || (this.propStatus == 'standart' && !this.hasDiscount)) {
        price = this.propPrice
      } else if (this.hasDiscount) {
        price = (this.hasDiscount && this.propDiscountPrice == 0) ? this.propPrice : this.propDiscountPrice || ''
      }

      return `https://www.landsbankinn.is/einstaklingar/lan-og-heimildir/bilalan?marketValue=${price}&utm_source=bilaskra.is`
    },
    price() {
      if (!this.propPrice) {
        return 'Sérpöntun';
      }
      return this.propPrice.format() + " " + this.propCurrency
    },
    priceDifference() {
      if (this.hasDiscount && this.propDiscountPrice == 0) {
        return this.propPrice.format() + " " + this.propCurrency
      }
      return this.propDiscountPrice ? (this.propDiscountPrice.format() + " " + this.propCurrency) : ''
    },
    hasDiscount() {
      if(this.car.is_special_price){
        return this.car.is_special_price;
      }
      return this.car.is_price_changing &&
          this.propPrice > this.propDiscountPrice;
      //return this.propDiscountPrice > 0 || this.car.retailDescription? true:false;
    },
    priceDiscount() {
      if (this.hasDiscount && this.propDiscountPrice == 0) {
        return 0;
      }
      return (this.propPrice - this.propDiscountPrice).format() + " " + this.propCurrency
    },
    showOldPrice(){
      return this.hasDiscount && this.propDiscountPrice && this.propPrice > this.propDiscountPrice;
    }
  }
};
</script>